export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/heifToJpeg.worker.3550cc01.worker.js");
}
